import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="The New Turing Omnibus"
        desc="66 excursions in computer science"
        image="/images/books/the-new-turing-omnibus.jpg"
        pageType="book"
        author="A.K. Dewdney"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/the-new-turing-omnibus.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                The New Turing Omnibus
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>A.K.Dewdney</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                A.K. Dewdney takes you on a tour of 66 essential topics in computer science, each
                presented as a short, self-contained chapter. From Turing machines and algorithms
                to fractals, neural networks, and computability, the book covers a remarkable
                breadth of ideas in an accessible and engaging way.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                What makes this book special is its format. Each chapter is short enough to read
                in a single sitting, yet deep enough to give you a real understanding of the topic.
                It is an excellent book for engineers who want to fill gaps in their computer science
                foundations, or for anyone curious about the ideas that shaped modern computing. The
                perfect book to pick up, read a chapter, and think about for the rest of the day.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
